import { render } from "./App.vue?vue&type=template&id=d6d3f1c6"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script